module.exports = __webpack_public_path__ + "static/media/order.ef39e01d.svg";